import { signal } from "@angular/core";
import { SchemaPathTree } from "@angular/forms/signals";
import { EVSiteType } from "src/models/units/unit-attributes.model";

export interface SiteTypeModel {
    siteType: EVSiteType;
    index: number;
    selected: boolean;
    displayText: string;
}
export interface SiteTypesFilterModel {
    siteTypes: SiteTypeModel[];
    expanded: boolean;
}

export function createSiteTypesModel() {
    return signal<SiteTypesFilterModel>({
        siteTypes: defaultSiteTypes,
        expanded: false,
    });
}

const defaultSiteTypes: SiteTypeModel[] = [    
    {
        siteType: EVSiteType.Freehold,
        index: 2,
        selected: true,
        displayText: "Selveier",
    },
    {
        siteType: EVSiteType.JudicialTenant,
        index: 3,
        selected: true,
        displayText: "Festet",
    }
];



export function buildSiteTypesModel(a: SchemaPathTree<SiteTypesFilterModel>) {}
